export default function VerticalSeparator() {
    return <div
        className="inline-block h-full min-h-[1em] w-0.5  bg-white rounded-full dark:bg-white/10"></div>
}